<template>
<v-container>
  <h2>
    担当者一覧を確認する
  </h2>
  <br>
  <div class="mb-3 body-2">
    OilMatrixに登録しているユーザー（担当者）情報について確認することができます。<br>
    本メニューはユーザー権限が「管理者」のユーザーのみが利用可能です。
  </div>

    <div class="mt-8 mb-4">
      <v-card  outlined color="teal" class="mx-auto" max-width="90%">
        <v-card-title>
          <v-icon color="white">mdi-phone-forward</v-icon>
          <span class="white--text body-1 font-weight-light">担当者情報の追加・削除・変更について</span>          
        </v-card-title>
        <v-card-text class="body-2 white--text">
         担当者情報の追加・削除・変更がある場合は、お手数ですがジャパン・アナリストまでご連絡ください。
        </v-card-text>
        <v-btn rounded color="body-2 amber darken-1 font-weight-bold"  @click="openInquiry()" class="mx-2 mb-5">
          <v-icon class="mr-2">mdi-comment-question-outline  </v-icon>ご連絡・お問合わせ
        </v-btn>
      </v-card>
    </div>

    <div class="my-8 mb-4">
      <h3>担当者画面への行き方</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      メニューの「担当者」をクリックすると、担当者画面が開きます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-confirm-01.png" width="70%" class="my-2">
    </div>

    <div class="my-8 mb-4">
      <h3>担当者の確認のしかた</h3>
      <v-divider></v-divider>
    </div>

    <div class="ml-4 my-4 body-2">
      事業所の選択リストから確認したい事業所を選択します。<br>
      選択した事業所に所属する担当者リストが表示されますので、リストから確認したいユーザーをクリックします。<br>
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-auth-05.png" width="90%" class="my-2">
    </div>

    <div class="ml-4 my-4 body-2">
      担当者詳細画面が開きます。内容を確認することができます。
    </div>
    <div class="ml-4 body-2">
      <img src="/img/man-employee-confirm-02.png" width="40%" class="my-2">
    </div>

    <div class="body-2" align="center">
      <v-card outlined class="pa-4" color="amber lighten-4" max-width="600px">
        <div class="body-2 mb-3">
          <v-icon>mdi-information-outline</v-icon>
          担当者権限の内容や変更方法については説明は下記マニュアルをご確認ください。
          </div>
        <div align="center">
          <v-btn small class="white--text" color="success" @click="showMan('manEmployeeAuth')">
            「担当者の権限を変更する」マニュアルを見る
          </v-btn>
        </div>
      </v-card>
    </div>

    <div class="my-4">
      <h3>担当者画面の項目説明</h3>
      <v-divider></v-divider>
    </div>
    <div class="ml-4 body-2">
      担当者リストの各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="employeeList">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in employeeList" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>

    <div class="ml-4 body-2">
      担当者詳細画面の各項目の説明です。
    </div>
    <div class="ml-4 my-4">
      <v-card outlined>
      <v-simple-table v-model="employeeData">
        <template v-slot:default>
          <thead>
            <tr style="background-color: grey">
              <th class="text-left white--text">項目名</th>
              <th class="text-left white--text">項目の説明</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in employeeData" :key="item.name">
              <td class="caption" width="140px">{{ item.name }}</td>
              <td class="caption">{{ item.body }}</td>
            </tr>
          </tbody>
        </template>        
      </v-simple-table>
      </v-card>
    </div>


</v-container>
</template>
<script>
export default {
    data: () => ({
//        inquiry_url: process.env.VUE_APP_INQUIRY_URL,
        inquiry_url: "https://www.japan-analysts.com/contact/",
        buttonName: '',
        employeeList: [
          {
            name: '担当者ID',
            body: 'システムにより担当者ごとに一意に採番されている番号です。通常の利用では使用しません。',
          },
          {
            name: '担当者名',
            body: '担当者の氏名です',
          },
          {
            name: '事業所',
            body: '所属する事業所名です',
          },
          {
            name: '所属',
            body: '所属する部署名です',
          },
          {
            name: '役職',
            body: '登録されている担当者の役職です。',
          },
          {
            name: 'email',
            body: '登録されているEメールアドレスです。',
          },
          {
            name: '権限',
            body: '設定されている権限です。',
          },
        ],
        employeeData: [
          {
            name: '担当者名',
            body: '担当者の氏名です',
          },
          {
            name: '許可ステータス',
            body: 'OilMatrixの利用許可状態を示します。「許可済」と「未許可」があります',
          },
          {
            name: '会社名',
            body: '所属する会社名です',
          },
          {
            name: '事業所',
            body: '所属する事業所名です',
          },
          {
            name: '部署名',
            body: '所属する部署名です',
          },
          {
            name: '電話番号',
            body: '登録されている担当者の電話番号です。',
          },
          {
            name: '携帯電話番号',
            body: '登録されている担当者の携帯電話番号です。',
          },
          {
            name: 'email',
            body: '登録されているEメールアドレスです。',
          },
        ],

    }),
    methods: {
      showMan: async function(value) {
        var url = '/UserManual/' + value
        this.$router.push(url)        
      },
      openInquiry() {
          window.open(this.inquiry_url, '_blank')
      },
    }
}
</script>

